var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{staticClass:"white--text",attrs:{"value":_vm.count,"height":"25"}},[_c('strong',[_vm._v(" "+_vm._s(_vm.distanceFromNow)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }